import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class EncryptionService {
  tokenFromUI: string = "xfgjerfjhkfSFfhQ";
  encrypted: any;
  decrypted: any;

  constructor() {}

  encryptUsingAES256(value: any) {
    // Allow 0, false, and empty string by only guarding undefined/null
    if (value !== undefined && value !== null) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CFB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return (this.encrypted = encrypted.toString());
  }
  }
  decryptUsingAES256(value: any) {
    if (value) {
      let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
      let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);

      this.decrypted = CryptoJS.AES.decrypt(value, _key, {
        keySize: 128,
        iv: _iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8);
      return this.decrypted;
    }
  }
}
